<template>
    <div class="membership-cancellation-membership">
        <h4>{{ membership.ref }} - {{ membership.currentPlan.getName() }}</h4>

        <div v-if="!membership.refundAmount"
             class="membership-refund-calculating text-center">
            <i class="fa-solid fa-arrows-rotate fa-spin"></i>
        </div>
        <div v-else
             class="membership-refunds selectable-btns">
            <a v-for="type in refundTypes"
               :key="type"
               class="btn btn-info"
               :class="[ (selectedRefundType === type ? 'active' : '') ]"
               @click="$emit('select-refund-type', membership.ID, type)">
                <div>
                    <small>{{ l('MEMBERSHIP_CANCELLATION.REFUND_' + type.toUpperCase()) }}</small>
                    <strong>{{ currencyFilter(membership.refundAmount[type + 'Total']) }}</strong>
                </div>
            </a>
        </div>
    </div>
</template>

<script>
import MembershipRefundType from '@/lib/Memberships/MembershipRefundType';

export default {
    props: {
        membership: {
            type: Object,
            required: true,
        },

        selectedRefundType: {
            type: String,
            default: null,
        },
    },

    emits: [
        // In Vue 2 emitted event names are case sensitive so we need to keep it in
        // kebab-case instead of selectRefundType.
        'select-refund-type',
    ],

    computed: {
        refundTypes() {
            return Object.values(MembershipRefundType)
                .filter((type) => this.membership.refundAmount.hasOwnProperty(type));
        },
    },
};
</script>

<style lang="less">
@import (reference) "../../../../less/variables";

.membership-cancellation-membership {
    background: @form-group-bg;
    border-radius: @border-radius-base;
    /**
     * This padding is purposely excessive so at 1024x768 the 4th membership will be half cut off vertically,
     * making it clearer there is more content to scroll down to.
     */
    padding: 15px 10px;
    margin: 10px 0;

    &:last-child {
        margin-bottom: 0;
    }

    h4 {
        margin: 0 10px 5px;
    }

    // All currency labels
    strong {
        display: block;
        font-size: 18px;
    }

    .membership-refund-calculating {
        min-height: 68px;
        padding-top: 21px;
    }

    .membership-refunds {
        display: flex;
        flex-wrap: nowrap;
        align-items: center;
        justify-content: center;

        > .btn {
            font-size: 15px;
            min-height: 70px;
            position: relative;
            white-space: normal;

            flex-basis: 33%;
            margin: 5px;
            padding: 17px; // Large enough to allow space for the tick icon when active

            // Vertically center content inside the boxes
            display: flex;
            align-items: center;
            justify-content: center;

            small {
                display: block;
                font-size: 11px;
            }
        }
    }
}
</style>
